import React from 'react'
import TerminalPayment from '../../assets/terminal-payment.png'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faCreditCard} from '@fortawesome/free-regular-svg-icons'

export interface VerifyPaymentTerminalProps {
  onPaymentCompleted: Function
  onPaymentError: Function
}

const VerifyPaymentTerminal = (props: VerifyPaymentTerminalProps) => {
  return (
    <div className="flex flex-col items-center justify-start gap-8">
      <p className="text-center">
        All reservations require payment validation. We perform a $0.10
        authorization to verify your payment method. When it is impossible, a
        minimum amount is authorized and immediately canceled. Rest assured, no
        funds will be withdrawn.
      </p>

      <img src={TerminalPayment} className="h-52 mx-auto" />

      <button
        className="btn btn-secondary btn-wide font-bold text-xl"
        onClick={() => {
          alert('send payment to terminal!')
        }}
      >
        <FontAwesomeIcon icon={faCreditCard} />
        <span>Use Card Reader</span>
      </button>
    </div>
  )
}

export default VerifyPaymentTerminal
